import { SvgIcon } from '@material-ui/core';

const HealthAndSafetyIcon = (props) => (
    <SvgIcon {...props}>
        <path d="M10.5 13H8v-3h2.5V7.5h3V10H16v3h-2.5v2.5h-3zM12 2 4 5v6.09c0 5.05 3.41 9.76 8 10.91 4.59-1.15 8-5.86 8-10.91V5z" />
    </SvgIcon>
);

export default HealthAndSafetyIcon; 